import { formatToGrs } from 'shared/time-utilites'
import { getRequestHeaders } from 'grs/api'
import { PromoCodeError, CreateReservationError } from 'booking/errors'
import { jsonPost } from 'api'
import { guestCheckoutReservationData, generateReservationList } from './dataMappers'

export const redeemPromoCode = (item, rawPromoCode, apiLanguageCode = 'EN', token) => {
    const {
        eDataLocationId: locationId,
        rateId,
        fromDate,
        toDate,
        actualFromDate,
        actualToDate,
        defaultCustomerFlow,
    } = item.rate

    const ReservationInfoData = {
        ACTUALFDATE: formatToGrs(actualFromDate),
        ACTUALTODATE: formatToGrs(actualToDate),
        LOC: locationId,
        RATEID: rateId,
        FD: formatToGrs(fromDate),
        TD: formatToGrs(toDate),
        PRMCODE: rawPromoCode,
        ISOLANGCODE: apiLanguageCode,
        CUSTOMERFLOWTYPE: defaultCustomerFlow,
        ...(item.bin && { BIN: item.bin }),
    }

    if (token) {
        ReservationInfoData.TOKEN = token
    }
    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/RedeemPromoCode`,
        {
            ReservationInfoData,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new PromoCodeError(error.message)
    })
}

export const createReservation = async ({
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    card,
    googlePayFields,
    boletoData,
    recaptchaToken,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    GOOGLE_PAY,
    PSE,
    paymentMethod,
}) => {
    const payload = {
        ReservationInfoList: generateReservationList({
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            card,
            googlePayFields,
            boletoData,
            startedWithProductId,
            inboundNumber,
            outboundNumber,
            additionalServices,
            GOOGLE_PAY,
            PSE,
            paymentMethod,
        }),
        Token: token,
        ISOLANGCODE: apiLanguageCode,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/CreateCartLoginReservationJSONPOST`,
        {
            ...payload,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}

export const createGuestUserReservation = async ({
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    recaptchaToken,
    inboundNumber,
    outboundNumber,
    PSE,
    nuveiSessionToken,
    googlePayFields,
    GOOGLE_PAY,
    paymentMethod,
    bin,
}) => {
    const payload = {
        ReservationInfoList: guestCheckoutReservationData(
            token,
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            inboundNumber,
            outboundNumber,
            nuveiSessionToken,
            PSE,
            GOOGLE_PAY,
            googlePayFields,
            paymentMethod,
            bin
        ),
        Is_EComm: true,
        ISOLANGCODE: apiLanguageCode,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/CreateCartLoginReservationJSONPOST`,
        {
            ...payload,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}

export const editReservation = async ({
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    card,
    googlePayFields,
    boletoData,
    recaptchaToken,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    GOOGLE_PAY,
    PSE,
    reservationId,
}) => {
    const payload = {
        ReservationInfoData: generateReservationList({
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            card,
            googlePayFields,
            boletoData,
            startedWithProductId,
            inboundNumber,
            outboundNumber,
            additionalServices,
            PIX,
            GOOGLE_PAY,
            PSE,
            reservationId,
        })[0],
        Token: token,
        ISOLANGCODE: apiLanguageCode,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/AmendCartReservationJSONPost`,
        {
            ...payload,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}

export const editGuestUserReservation = async ({
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    card,
    boletoData,
    recaptchaToken,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    PSE,
    reservationId,
}) => {
    const payload = {
        ReservationInfoData: generateReservationList({
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            card,
            boletoData,
            startedWithProductId,
            inboundNumber,
            outboundNumber,
            additionalServices,
            PIX,
            PSE,
            reservationId,
        })[0],
        ISOLANGCODE: apiLanguageCode,
        Is_EComm: true,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/GuestAmendCartReservationJSONPOST`,
        {
            ...payload,
            ISOLANGCODE: apiLanguageCode,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}
